export default ThankYou => (data, editing = false) => ({
    editing,
    init() {

        if (this.editing === true) {
            return
        }

        this.$store.audioManager.playCompletedWebFormAudio(data.completedAudio)
        this.$store.runAfterEnterThankYouPageHook(data)
        ThankYou.state.thankYouPageId = data.key
        ThankYou.controller.confirm(data.key, data.ruleId)

        this.$store.rotationManager.start(async() => {
            await ThankYou.controller.rotate()
        })

    },
    destroy() {
        this.$store.rotationManager.stop()
    },
})
